import { Component, OnInit } from '@angular/core';

import { AppService } from '../../services/app.service';
import { ITableColumn } from '../../shared/table/table.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DiplomaSupplementService } from '../../services/diploma-supplement.service';
import { IDiplomaSupplementListModel } from '../../models/DiplomaSupplement';
import { DiplomaSupplementChangeContactPersonComponent } from './change-contact-person.component';

@Component({
    selector: 'app-diploma-supplement-list',
    templateUrl: './list.component.html'
})
export class DiplomaSupplementListComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: DiplomaSupplementService,
        private modal: NgbModal
    ) { }

    items: IDiplomaSupplementListModel[] = [];

    page: number = 1;
    readonly pageSize: number = 10;
    total: number = 0;
    sortBy: string;
    sortDir: 'asc' | 'desc';

    readonly columns: ITableColumn[] = [
        { property: 'FullName', label: 'diplomaSupplement_lblFullName', sorts: true },
        { property: 'Upn', label: 'diplomaSupplement_lblUpn', sorts: true },
        { property: 'ProgramName', label: 'diplomaSupplement_lblProgram', sorts: true },
        { property: 'Language', label: 'diplomaSupplement_lblStudyLanguage', sorts: true },
        { property: 'ContactPerson', label: 'diplomaSupplement_lblContactPerson', sorts: true },
        { property: 'Registered', label: 'diplomaSupplement_lblRegistered', sorts: true, type: 'date' }
    ];

    readonly filters: {
        text?: string,
        program: { options: string[], value: string },
        semester: { options: string[], value: string },
        contactPerson: { options: string[], value: string }
    } = {
            program: { options: [], value: undefined },
            semester: { options: [], value: undefined },
            contactPerson: { options: [], value: undefined }
        };

    get isAdmin() {
        return this.app.currentUser.hasRight('DIPLOMA_SUPPLEMENT.ADMIN');
    }

    private allItems: IDiplomaSupplementListModel[] = [];
    private selected: number[] = [];
    private filterTimeout: any;

    ngOnInit() {
        if (this.isAdmin) {
            this.columns.unshift({ width: '1px' });
        }

        this.app.addLoading(this.service.getFilters()).subscribe(data => {
            this.filters.program.options = data.programs;
            this.filters.semester.options = data.semesters;
            this.filters.contactPerson.options = data.contactPersons;
        });

        this.fetch();
    }

    filter(delay: boolean = false) {
        if (delay) {
            if (this.filterTimeout) {
                clearTimeout(this.filterTimeout);
            }

            this.filterTimeout = setTimeout(() => {
                this.page = 1;
                this.fetch();
            }, 300);
        } else {
            this.page = 1;
            this.fetch();
        }
    }

    onPage(event: number) {
        this.page = event;

        this.fetch();
    }

    onSort(event: { sortBy: string, sortDir: 'asc' | 'desc' }) {
        this.sortBy = event.sortBy;
        this.sortDir = event.sortDir;

        this.fetch();
    }

    changeContactPerson() {
        const ref = this.modal.open(DiplomaSupplementChangeContactPersonComponent, { size: 'md' });
        ref.componentInstance.selected = this.selected;
        ref.componentInstance.filtered = {
            program: this.filters.program.value,
            semester: this.filters.semester.value,
            contactPerson: this.filters.contactPerson.value,
            search: this.filters.text,
            total: this.total
        };
        ref.result.then(() => {
            this.fetch();
        }, () => { });
    }

    toggle(id: number) {
        const ix = this.selected.indexOf(id);

        if (ix == -1) {
            this.selected.push(id);
        } else {
            this.selected.splice(ix, 1);
        }
    }

    private fetch() {
        this.app.addLoading(this.service.get({
            paging: {
                page: this.page,
                size: this.pageSize,
                dir: this.sortDir,
                sort: this.sortBy
            },
            filter: {
                contactPerson: this.filters.contactPerson.value,
                program: this.filters.program.value,
                semester: this.filters.semester.value,
                search: this.filters.text
            }
        })).subscribe(data => {
            this.allItems = data.items;
            this.total = data.total;

            this.items = this.allItems;
        });
    }
}
